var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"queued-winner-popup"},[_c('div',[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.status))]),_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('button',{on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v("Volver al menu")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }